export default __webpack_public_path__ + "static/media/pexels-pixabay-47349.3e5c1773.jpg";